import { TbCloudCog } from "react-icons/tb";

import { ComponentWithAs, IconProps } from "@chakra-ui/react";

import { DashboardIcon, DocumentationIcon, LogoutIcon } from "@/components/shared/ReleaseIcons";

export const instantDatasetsTopNavMenuItems = [
  {
    label: "Datasets",
    icon: DashboardIcon,
    slug: "datasets",
    pathname: "/workspaces/[workspaceId]/instantdatasets/datasets",
  },
  {
    label: "Cloud Integrations",
    icon: TbCloudCog as ComponentWithAs<"svg", IconProps>,
    slug: "cloud_integrations",
    pathname: "/workspaces/[workspaceId]/instantdatasets/cloud_integrations",
  },
] as const;

export const instantDatasetsBottomNavMenuItems = [
  {
    label: "Quickstart Guide",
    icon: DocumentationIcon,
    slug: "quickstart",
    pathname: "https://docs.release.com/release-instant-datasets/quickstart",
    external: true,
  },
  { label: "Log out", icon: LogoutIcon, slug: "logout", pathname: "/logout" },
] as const;

const allItems = [...instantDatasetsTopNavMenuItems, ...instantDatasetsBottomNavMenuItems] as const;
export type InstantDatasetsNavMenuItemSlug = (typeof allItems)[number]["slug"];
